import { createSelector } from 'reselect';

import { NEXT_AVAILABILITY_KEY } from './constants';

export const nextAvailabilitySelector = createSelector(
    state => state[NEXT_AVAILABILITY_KEY],
    nextAvailability => nextAvailability
);
